import { UiContentCenteredComponent } from '@common/ui/frontend-shared/content-centered';
import { UiButtonComponent } from '@common/ui/frontend-shared/button';
import { RouterModule } from '@angular/router';
import * as i0 from "@angular/core";
import * as i1 from "@common/ui/frontend-shared/card";
import * as i2 from "@angular/router";
function CoreErrorMessageComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("(", ctx_r0.error.status, ")");
  }
}
export let CoreErrorMessageComponent = /*#__PURE__*/(() => {
  class CoreErrorMessageComponent {
    constructor() {
      this.e2eErrorCode = '0';
    }
    isNumber(val) {
      return typeof val === 'number';
    }
    ngOnInit() {
      this.e2eErrorCode = '' + this.error.status;
    }
    static {
      this.ɵfac = function CoreErrorMessageComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CoreErrorMessageComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: CoreErrorMessageComponent,
        selectors: [["core-error-message"]],
        hostVars: 1,
        hostBindings: function CoreErrorMessageComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("e2e-error-page", ctx.e2eErrorCode);
          }
        },
        inputs: {
          error: "error"
        },
        decls: 10,
        vars: 3,
        consts: [["size", "small"], [1, "bottom"], ["uiButton", "", "label", "Zur\u00FCck zur Startseite", "routerLink", "/"]],
        template: function CoreErrorMessageComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "ui-content-centered")(1, "div")(2, "ui-card", 0)(3, "h1");
            i0.ɵɵtext(4);
            i0.ɵɵconditionalCreate(5, CoreErrorMessageComponent_Conditional_5_Template, 2, 1, "span");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "p");
            i0.ɵɵtext(7);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(8, "p", 1);
            i0.ɵɵelement(9, "button", 2);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate1("", ctx.error.summary, " ");
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.isNumber(ctx.error.status) ? 5 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.error.message);
          }
        },
        dependencies: [UiContentCenteredComponent, UiButtonComponent, i1.UiCardComponent, RouterModule, i2.RouterLink],
        styles: ["[_nghost-%COMP%]{text-align:center}div[_ngcontent-%COMP%]{max-width:100%}h1[_ngcontent-%COMP%], h3[_ngcontent-%COMP%]{margin:0}.bottom[_ngcontent-%COMP%]{margin-top:40px}\n\n/*# sourceMappingURL=error-message.component.ts-angular-inline--34.css.map*/"]
      });
    }
  }
  return CoreErrorMessageComponent;
})();